module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "custom-random"
  }, [_c('v-slide-y-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": ""
    }
  }, [_c('v-list', [_vm._l((_vm.items), function(item, index) {
    return [_c('v-list-tile', {
      key: 'item-item-' + index,
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-content', [_c('v-text-field', {
      attrs: {
        "name": 'item-input-' + index,
        "label": index.toString(),
        "value": item,
        "autofocus": index + 1 == _vm.items.length
      },
      model: {
        value: (_vm.items[index]),
        callback: function($$v) {
          _vm.$set(_vm.items, index, $$v)
        },
        expression: "items[index]"
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": "",
        "dark": "",
        "small": "",
        "color": "red"
      },
      on: {
        "click": function($event) {
          _vm.removeItem(index)
        }
      }
    }, [_c('v-icon', [_vm._v("remove")])], 1)], 1)], 1)]
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-btn', {
    attrs: {
      "block": "",
      "outline": "",
      "color": _vm.themeColor
    },
    on: {
      "click": function($event) {
        _vm.addItem(_vm.items.length)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-text-field', {
    attrs: {
      "name": "count",
      "type": "number",
      "label": _vm.$t('Count')
    },
    model: {
      value: (_vm.count),
      callback: function($$v) {
        _vm.count = $$v
      },
      expression: "count"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', {
    staticClass: "options-wrap"
  }, [_c('v-switch', {
    attrs: {
      "label": _vm.$t('Is Repeat'),
      "value": _vm.isRepeat
    },
    model: {
      value: (_vm.isRepeat),
      callback: function($$v) {
        _vm.isRepeat = $$v
      },
      expression: "isRepeat"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": _vm.$t('Automatically Clear The Last Result'),
      "value": _vm.isAutoClear
    },
    model: {
      value: (_vm.isAutoClear),
      callback: function($$v) {
        _vm.isAutoClear = $$v
      },
      expression: "isAutoClear"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-btn', {
    attrs: {
      "block": "",
      "dark": "",
      "color": _vm.themeColor
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('Randomize'))
    },
    on: {
      "click": _vm.handleRandom
    }
  })], 1)], 1)], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('navigation-drawer-with-toggle', {
    model: {
      value: (_vm.isOpen),
      callback: function($$v) {
        _vm.isOpen = $$v
      },
      expression: "isOpen"
    }
  }, [_c('v-list', [_vm._l((_vm.result), function(item, index) {
    return [_c('v-list-tile', {
      key: 'list-item-' + index,
      class: {
        gray: index > _vm.count - 1
      },
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item)
      }
    })], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: 'list-divider-' + index
    })]
  }), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": _vm.themeColor,
      "dark": ""
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('Clear'))
    },
    on: {
      "click": _vm.handleClearResult
    }
  })], 1)], 1)], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "value": _vm.isOpenSaveWindow,
      "max-width": "290"
    },
    on: {
      "input": _vm.toggleOpenSaveWindow
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline",
    domProps: {
      "textContent": _vm._s(_vm.$t('Save'))
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "autofocus": "",
      "label": _vm.$t('Item Name')
    },
    model: {
      value: (_vm.inputName),
      callback: function($$v) {
        _vm.inputName = $$v
      },
      expression: "inputName"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('Cancel'))
    },
    on: {
      "click": function($event) {
        _vm.setOpenSaveWindow(false)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": _vm.themeColor
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('Save'))
    },
    on: {
      "click": _vm.saveToLocal
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "value": _vm.isOpenDeleteWindow,
      "max-width": "290"
    },
    on: {
      "input": _vm.toggleOpenDeleteWindow
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline",
    domProps: {
      "textContent": _vm._s(_vm.$t('Delete'))
    }
  }), _vm._v(" "), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('Are you sure to delete it ?')) + "\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": _vm.themeColor
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('Cancel'))
    },
    on: {
      "click": function($event) {
        _vm.setOpenDeleteWindow(false)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('Delete'))
    },
    on: {
      "click": _vm.deleteToLocal
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe4dbf04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/CustomRandom.vue
// module id = 438
// module chunks = 1